// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__NyQKw","skeleton":"styles_skeleton__Djp7S","hr":"styles_hr__PDSz6","row":"styles_row__ct-SH"};